export default {
  login: {
    title: 'Log Masuk',
    usernameLabel: 'Nama pengguna',
    usernamePlaceholder: '2-10 kombinasi digit bahasa Inggeris bermula dengan bahasa Inggeris',
    loginPasswordLabel: 'kata laluan log masuk',
    loginPasswordPlaceholder: 'Sila masukkan kata laluan log masuk anda',
    googleCodeLabel: 'Kod pengesahan Google',
    googleCodePlaceholder: 'Sila masukkan kod pengesahan Google 6 digit',
    hasNoAccount: 'Belum ada akaun,',
    goRegister: 'Pergi untuk mendaftar',
    onlineCustom: 'Perkhidmatan pelanggan dalam talian',
    loginArgument: 'Teruskan log masuk bermakna bersetuju',
    userArgument: '《Perjanjian Pengguna》',
    registerNotEnabled: 'Fungsi pendaftaran tidak dibuka, sila hubungi pentadbir',
    usernameRequired: 'Sila masukkan nama pengguna yang betul',
    loginPasswordRequired: 'Sila masukkan kata laluan log masuk yang betul',
    googleCodeRequired: 'Sila masukkan kod pengesahan Google yang betul',
    loginButton: 'log masuk'
  },
  register: {
    title: 'Daftar',
    usernameLabel: 'Nama pengguna',
    usernamePlaceholder: 'Sila masukkan nama pengguna berdaftar',
    loginPasswordLabel: 'kata laluan log masuk',
    loginPasswordPlaceholder: 'Sila masukkan kata laluan log masuk pengguna berdaftar',
    loginPasswordPreLabel: 'Sahkan kata laluan log masuk',
    loginPasswordPrePlaceholder: 'Sila masukkan kata laluan log masuk sekali lagi',
    fudPasswordLabel: 'kata laluan dana',
    fudPasswordPlaceholder: 'Sila masukkan kata laluan dana',
    inviteCodeLabel: 'Kod Jemputan',
    inviteCodePlaceholder: 'Sila masukkan kod jemputan 6 digit',
    registerNeed: 'Teruskan mendaftar bermakna bersetuju',
    registerArgument: '《Perjanjian Pendaftaran》',
    usernameRequired: 'Sila masukkan nama pengguna yang betul',
    loginPasswordRequired: 'Sila masukkan kata laluan log masuk yang betul',
    loginPasswordPreRequired: 'Sila masukkan kata laluan log masuk pengesahan yang betul',
    fundPasswordRequired: 'Sila masukkan kata laluan dana yang betul',
    inviteCodeRequired: 'Sila masukkan kod jemputan yang betul',
    diffLoginPasswordError: 'Dua kata laluan log masuk tidak konsisten',
    registerSuccess: 'Pendaftaran berjaya',
    registerButton: 'Daftar',
    emailLabel: 'E-mel',
    emailPlaceholder: 'Sila masukkan alamat e-mel anda',
    emailCodeLabel: 'Kod pengesahan',
    emailCodePlaceholder: 'Sila masukkan kod pengesahan e-mel anda',
    second: 'kedua',
    getEmailCodeButton: 'Dapatkan kod',
    emailRequired: 'Sila masukkan alamat e-mel yang betul dan cuba lagi',
    emailCodeRequired: 'Sila masukkan kod pengesahan e-mel yang betul dan cuba lagi'
  },
  home: {
    hotCoin: {
      title: 'Tawaran hebat',
      more: 'lagi'
    },
    poster: {
      title: 'Deposit cepat',
      enter: 'Masuk sekarang>',
      subTitle: 'Sokong BTC, USDT, ETH, dsb.'
    },
    quickMenus: {
      futuresTrading: 'Perdagangan Niaga Hadapan',
      helpCenter: 'Pusat Bantuan'
    },
    ranking: {
      increase: {
        title: 'Senarai meningkat'
      },
      clinch: {
        title: 'Senarai Perolehan'
      }
    }
  },
  tabBar: {
    home: 'Rumah',
    price: 'sebut harga',
    trade: 'Perdagangan',
    fund: 'Aset',
    user: 'saya'
  },
  currency: {
    favorite: 'Pilihan',
    allCurrency: 'spot',
    dayVol: 'jumlah 24J',
    addFavor: '+ Add Favor'
  },
  trade: {
    bills: 'Bills',
    todayOpen: 'Buka',
    star: 'Pilihan',
    vol: 'Volume',
    low: 'paling rendah',
    high: 'tertinggi',
    timing: 'cepat',
    spot: 'niaga hadapan',
    buyMore: 'beli lagi',
    buyEmpty: 'beli pendek',
    indicator: 'Penunjuk',
    indicatorSettings: 'Tetapan Penunjuk',
    balance: 'baki saya',
    fee: 'yuran perkhidmatan',
    ruleIdError: 'Sila pilih masa tamat tempoh',
    deleteFavoriteSuccess: 'Berjaya memadam mata wang kegemaran',
    addFavoriteSuccess: 'Menambahkan mata wang yang dipilih berjaya',
    buyIn: 'beli',
    sellout: 'Jual',
    holding: 'memegang kedudukan',
    history: 'Sejarah',
    spotOrderConfirm: {
      title: 'Sahkan Beli',
      amountPlaceholder: 'Sila masukkan kuantiti pembelian'
    },
    spotTradeOrder: {
      holding: {
        coin: 'mata wang',
        buyInAmountPrice: 'Amaun/Harga Beli',
        buyInCount: 'Kuantiti',
        actions: 'Operasi',
        sellout: 'Jual',
        profit: 'Untung'
      }
    },
    orderConfirm: {
      title: 'Pengesahan Pesanan',
      coinName: 'mata wang',
      direction: 'arah',
      price: 'harga semasa',
      balance: 'Baki',
      fee: 'yuran perkhidmatan',
      buyMoreLabel: 'beli lebih banyak',
      buyEmptyLabel: 'beli pendek',
      buyQuantity: 'Beli kuantiti',
      buyAmount: 'Jumlah Belian',
      submit: 'Mengesahkan pesanan'
    },
    kline: {
      open: 'Buka:',
      close: 'tutup:',
      change: 'Naik dan turun:'
    }
  },

  finance: {
    title: 'Kewangan'
  },
  allFinance: {
    title: 'Pengurusan kewangan',
    all: 'semua'
  },
  financeOrders: {
    title: 'Perintah ikrar',
    holdingLabel: 'memegang',
    historyLabel: 'Sejarah',
    holding: {
      amount: 'Jumlah ikrar',
      rateStr: 'jumlah pendapatan/hasil',
      vcCount: 'Bilangan syiling yang dicagarkan',
      cycle: 'Kitaran kedudukan',
      day: 'hari',
      calcStartDate: 'Tarikh nilai mula',
      serviceAmount: 'Yuran Perkhidmatan',
      redeemOrder: 'Tebus'
    },
    history: {
      incomeAmount: 'jumlah pendapatan',
      rateStr: 'hasil',
      amount: 'Jumlah ikrar',
      vcCount: 'Bilangan syiling yang dicagarkan',
      calcStartDate: 'Tarikh nilai mula',
      calcEndDate: 'Tarikh Tamat',
      cycle: 'hari kitaran',
      serviceAmount: 'Yuran Perkhidmatan',
      day: 'hari'
    }
  },
  financeOrderBills: {
    title: 'Bil pendapatan ikrar',
    amount: 'jumlah',
    balance: 'Baki'
  },
  financeItem: {
    rateStr: 'hasil',
    buyType: 'Jenis Beli',
    cycle: 'hari kitaran',
    exchangeRate: 'Kadar pertukaran (baki pertukaran mata wang maya)',
    day: 'hari',
    cycleType: 'jenis kitaran',
    serviceRateStr: 'Kadar Perkhidmatan'
  },
  buyFinance: {
    title: 'Beli',
    rateStr: 'hasil',
    nama: 'nama',
    buyType: 'Jenis Beli',
    cycle: 'hari kitaran',
    cycleType: 'jenis kitaran',
    exchangeRate: 'Kadar pertukaran (baki pertukaran mata wang maya)',
    serviceRateStr: 'Kadar Perkhidmatan',
    remark: 'remark',
    buyAmountLabel: 'Amaun Beli ({coin})',
    descriptionTitle: 'Perihalan Produk',
    descriptionPart1: '1. Produk ini ialah produk pengurusan kekayaan yang tidak dijamin oleh prinsipal. Turun naik pasaran boleh menyebabkan kerugian prinsipal. Sila melabur dengan berhati-hati.',
    descriptionPart2: '2. Peraturan penyelesaian pembayaran:',
    descriptionPart3: 'Jika harga penyelesaian < harga terpaut, BTC akan diselesaikan selepas matang; jumlah penyelesaian = jumlah pelaburan * (1+ hari * kadar pulangan tahunan / 365).',
    descriptionPart4: 'Jika harga penyelesaian ≥ harga terpaut, USDT akan dijelaskan selepas matang; jumlah penyelesaian = jumlah pelaburan * harga terpaut * (1+ hari * kadar pulangan tahunan / 365).',
    descriptionPart5: '3. Kadar pulangan tahunan sebenar berubah dengan pasaran dalam masa nyata, sila rujuk transaksi pembelian sebenar.',
    descriptionPart6: '4. Amaun pelaburan ditukar mengikut pasaran dalam masa nyata, sila rujuk transaksi pembelian sebenar.',
    descriptionPart7: '5. Selepas produk dibeli, ia boleh dilihat pada halaman pegangan mata wang saya, dan bayaran balik akan dikeluarkan secara automatik ke akaun spot selepas tarikh tamat tempoh.',
    buyButton: 'Beli [{coin}]'
  },

  fund: {
    description: 'aset',
    recharge: 'Deposit',
    withdraw: 'Menarik diri',
    exchange: 'Pemindahan',
    empty: 'Dompet kosong, pergi'
  },
  userCenter: {
    lastLogin: 'Masa log masuk',
    myTeam: 'Pasukan Saya',
    identity: 'pengesahan nama sebenar',
    walletAddress: 'alamat dompet',
    zskAccount: 'Akaun pantas',
    bankCard: 'Akaun bank',
    userBills: 'Rekod Perubahan Akaun',
    timingTradeOrder: 'Kedudukan yang sangat pantas',
    spotTradeOrder: 'Kedudukan niaga hadapan',
    contactTradeOrder: 'Kedudukan kontrak',
    userReport: 'Laporan Pengguna',
    teamReport: 'laporan pasukan',
    share: 'Saya mahu berkongsi',
    customer: 'Hubungi perkhidmatan pelanggan',
    helpCenter: 'Pusat Bantuan',
    platform: 'Pengenalan Platform',
    profit: 'untung dan rugi hari ini',
    balance: 'Baki saya',
    withdraw: 'Menarik diri',
    recharge: 'Deposit',
    creditStoreLabel: 'Mata Kredit'
  },
  settings: {
    title: 'Tetapan',
    fundPassword: 'kata laluan dana',
    googleValidator: 'Google Validator',
    editLoginPassword: 'Tukar kata laluan log masuk',
    switchLocale: 'tukar bahasa'
  },
  editFundPassword: {
    title: 'Tukar Kata Laluan Dana',
    currentPasswordLabel: 'kata laluan semasa',
    currentPasswordPlaceholder: 'Sila masukkan kata laluan dana semasa',
    newPasswordLabel: 'Kata Laluan Baharu',
    newPasswordPlaceholder: 'Sila masukkan kata laluan dana yang diubah suai',
    prePasswordLabel: 'Sahkan kata laluan',
    prePasswordPlaceholder: 'Kosongkan dan masukkan semula kata laluan dana yang diubah suai',
    tips: 'Kata laluan dana ialah sijil penting untuk urus niaga, sila tetapkannya dengan teliti dan ingatkannya',
    currentPasswordRequired: 'Sila masukkan kata laluan dana semasa',
    newPasswordRequired: 'Sila masukkan kata laluan dana untuk diubah suai',
    prePasswordRequired: 'Sila masukkan kata laluan dana untuk diubah suai semula',
    prePasswordDiff: 'Dua input kata laluan tidak konsisten'
  },
  bindFundPassword: {
    title: 'Ikat kata laluan dana',
    fundPasswordLabel: 'kata laluan dana',
    fundPasswordPlaceholder: 'Sila masukkan kata laluan dana',
    fundPasswordPreLabel: 'Sahkan kata laluan',
    fundPasswordPrePlaceholder: 'Sila masukkan kata laluan dana sekali lagi',
    fundPasswordRequired: 'Sila masukkan kata laluan dana yang betul',
    fundPasswordPreRequired: 'Sila masukkan kata laluan pengesahan yang betul',
    fundPasswordDiff: 'Kedua-dua kata laluan tidak konsisten',
    bindSuccess: 'Kata laluan dana berjaya diikat',
    tips: 'Kata laluan dana ialah bukti kelayakan penting untuk urus niaga, sila tetapkannya dengan berhati-hati dan ingatkannya'
  },
  editLoginPassword: {
    title: 'Tukar kata laluan log masuk',
    currentPasswordLabel: 'kata laluan semasa',
    currentPasswordPlaceholder: 'Sila masukkan kata laluan log masuk semasa',
    newPasswordLabel: 'Kata Laluan Baharu',
    newPasswordPlaceholder: 'Sila masukkan kata laluan log masuk yang diubah suai',
    prePasswordLabel: 'Sahkan kata laluan',
    prePasswordPlaceholder: 'Kosongkan dan masukkan semula kata laluan log masuk yang diubah suai',
    tips: 'Kata laluan log masuk ialah bukti kelayakan penting untuk pengesahan log masuk, dsb., sila tetapkannya dengan berhati-hati dan ingatkannya',
    currentPasswordRequired: 'Sila masukkan kata laluan log masuk semasa',
    newPasswordRequired: 'Sila masukkan kata laluan log masuk untuk diubah suai',
    prePasswordRequired: 'Sila masukkan semula kata laluan log masuk untuk diubah suai',
    prePasswordDiff: 'Dua input kata laluan tidak konsisten'
  },
  bindGoogleValidator: {
    title: 'Bind Google Authenticator',
    qrCodeLabel: 'Kod QR',
    keyLabel: 'Kunci',
    loginPasswordLabel: 'kata laluan log masuk',
    loginPasswordPlaceholder: 'Sila masukkan kata laluan log masuk anda',
    googleCodeLabel: 'Kod pengesahan Google',
    googleCodePlaceholder: 'Sila masukkan kod pengesahan Google 6 digit',
    tipsPart1: 'Cari Google Authenticator dalam gedung aplikasi',
    tipsPart2: 'Gunakan Google Authenticator untuk mengimbas kod QR di atas, atau masukkan kekunci secara manual untuk mengikat',
    tipsPart3: 'Masukkan kod pengesahan Google 6 digit di atas, klik Sahkan untuk menyerahkan',
    loginPasswordDiperlukan: 'Sila masukkan kata laluan log masuk',
    googleCodeRequired: 'Sila masukkan kod pengesahan Google 6 digit'
  },
  walletAddress: {
    title: 'Alamat dompet',
    add: '+ tambah alamat dompet',
    remark: 'remark',
    addButton: 'Tambah alamat dompet',
    tips: 'Jika anda ingin mengubah suai atau memadam maklumat alamat, sila hubungi perkhidmatan pelanggan'
  },
  addWalletAddress: {
    title: 'Tambah alamat dompet',
    vcChainNameIdLabel: 'jenis rantai',
    vcAccountLabel: 'alamat dompet',
    vcAccountPlaceholder: 'Sila masukkan alamat dompet',
    remarkLabel: 'Remarks',
    remarkPlaceholder: 'Sila masukkan kandungan catatan',
    fundPasswordLabel: 'kata laluan dana',
    fundPasswordPlaceholder: 'Sila masukkan kata laluan dana anda',
    tips: 'Alamat dompet yang ditambahkan tidak boleh diubah suai, sila sahkan bahawa maklumat itu betul',
    vcIdRequired: 'Sila pilih mata wang yang betul',
    vcChainNameIdRequired: 'Sila pilih jenis rantai yang betul',
    vcAccountRequired: 'Sila masukkan alamat dompet yang betul',
    fundPwdRequired: 'Sila masukkan kata laluan dana yang betul',
    addSuccess: 'Alamat dompet berjaya ditambahkan'
  },
  receiveWays: {
    title: 'Kad Bank Saya',
    add: '+ Tambah kad bank',
    tips: 'Jika anda ingin mengubah suai atau memadam maklumat kad bank, sila hubungi perkhidmatan pelanggan',
    addCardButton: 'Tambah kad bank'
  },
  zskAccount: {
    title: 'Akaun pantas',
    add: '+ Tambah akaun pantas',
    tips: 'Untuk mengubah suai atau memadam maklumat akaun, sila hubungi perkhidmatan pelanggan',
    addCardButton: 'Tambah akaun'
  },
  addZskAccount: {
    title: 'Tambah akaun pantas',
    withdrawNameLabel: 'Nama',
    withdrawNamePlaceholder: 'Sila masukkan nama anda',
    withdrawNameRequired: 'Nama tidak dibenarkan kosong',
    zskLabel: 'ZSK',
    zskPlaceholder: 'Sila masukkan ID kelajuan pantas',
    fundPasswordLabel: 'kata laluan dana',
    fundPasswordPlaceholder: 'Sila masukkan kata laluan dana anda',
    tips: 'Sila isi dengan teliti maklumat akaun yang ditambahkan, syarikat tidak akan bertanggungjawab terhadap masalah pengeluaran gagal tiba kerana maklumat yang salah'
  },
  addBankCard: {
    title: 'Tambah kad bank baharu',
    cardNumLabel: 'Nombor kad bank',
    withdrawNameLabel: 'Nama',
    withdrawNamePlaceholder: 'Sila masukkan nama anda',
    withdrawNameRequired: 'Nama tidak dibenarkan kosong',
    zskLabel: 'ZSK',
    zskPlaceholder: 'Sila masukkan ID kelajuan pantas',
    zskRequired: 'Sila masukkan ID kelajuan yang betul',
    cardNumPlaceholder: 'Sila masukkan nombor kad bank',
    branchLabel: 'Alamat cawangan',
    branchPlaceholder: 'Sila masukkan alamat cawangan kad bank',
    fundPasswordLabel: 'kata laluan dana',
    fundPasswordPlaceholder: 'Sila masukkan kata laluan dana',
    tips: 'Kad bank adalah data penting untuk pengeluaran tunai transaksi, sila isi dengan teliti, syarikat tidak akan bertanggungjawab terhadap sebarang masalah seperti kegagalan menerima wang tunai kerana pengisian maklumat kad yang salah. ',
    backIdRequired: 'Sila pilih bank akaun',
    cardNumRequired: 'Sila masukkan nombor kad bank yang betul',
    fundPwdRequired: 'Sila masukkan kata laluan dana yang betul',
    idCardPlaceholder: 'Sila masukkan nombor ID anda',
    idCardLabel: 'Nombor kad ID',
    idCardRequired: 'Sila masukkan nombor ID yang betul',
    cciPlaceholder: 'Sila masukkan CCI kad bank',
    branchCodePlaceholder: 'Sila masukkan kod cawangan',
    branchCodeLabel: 'Kod Cawangan',
    katakanaPlaceholder: 'Sila masukkan katakana',
    katakanaLabel: 'Katakana'
  },
  userBills: {
    title: 'Rekod Perubahan Akaun',
    vcName: 'Mata Wang',
    amount: 'jumlah',
    balance: 'Baki'
  },
  timingTradeOrder: {
    title: 'Pesanan Dagangan Amat Cepat',
    waiting: {
      title: 'Pesanan sedang berjalan',
      amount: 'jumlah',
      period: 'tempoh',
      receivePrice: 'Harga beli',
      settlement: 'penyelesaian sedang berjalan'
    },
    spotTradeOrder: {
      title: '期货交易订单',
      waiting: {
        title: '在持订单',
        buyInAmount: '买入总价',
        buyInPrice: '买入单价',
        buyInCount: '买入数量',
        buyInTime: '买入时间'
      },
      history: {
        title: '历史订单',
        buyInAmount: '买入总价',
        buyInPrice: '买入单价',
        buyInCount: '买入数量',
        sellOutAmount: '卖出总价',
        sellOutPrice: '卖出单价',
        sellOutTime: '卖出时间'
      }
    },
    history: {
      title: 'Perintah Sejarah',
      buyInClose: 'Harga beli',
      saleOutClose: 'harga jualan'
    }
  },
  userReport: {
    title: 'Laporan Pengguna',
    profit: 'Keuntungan',
    timingTradeAmountFee: 'Yuran pesanan/pengendalian dagangan yang sangat pantas',
    timingTradePrizePoint: 'Bonus/rebat dagangan yang sangat pantas',
    rechargeInfo: 'Caj semula/yuran pengendalian',
    withdrawInfo: 'Yuran pengeluaran/pengendalian',
    exchangeInfo: 'Yuran pertukaran/pengendalian'
  },
  userReportDay: {
    title: 'Laporan Harian Pengguna',
    profit: 'Keuntungan',
    timingTradeAmountFee: 'Yuran pesanan/pengendalian dagangan yang sangat pantas',
    timingTradePrizePoint: 'Bonus/rebat dagangan yang sangat pantas',
    rechargeInfo: 'Caj semula/yuran pengendalian',
    withdrawInfo: 'Yuran pengeluaran/pengendalian',
    exchangeInfo: 'Yuran pertukaran/pengendalian'
  },
  teamReport: {
    title: 'Laporan Pasukan',
    goToReportDay: 'Lihat laporan harian',
    timingTradeBetAmountServiceCharge: 'Caj pesanan/perkhidmatan dagangan yang sangat pantas',
    timingTradeBetPrizePoint: 'Bonus/Rebat Dagangan Cepat',
    timingTradeUserAndCount: 'Bilangan peniaga kelajuan/bilangan transaksi',
    rechargeAmountFee: 'Jumlah caj semula/yuran perkhidmatan',
    rechargePersonCount: 'Caj semula orang/bilangan transaksi',
    withdrawAmountFee: 'amaun pengeluaran/yuran perkhidmatan',
    withdrawPersonCount: 'Bilangan orang yang mengeluarkan wang/urus niaga',
    firstRechargeUserAndCount: 'Jumlah caj semula pertama/bilangan orang',
    usernamePlaceholder: 'Masukkan nama pengguna peringkat bawah',
    previewAllTradeInfo: 'Lihat semua maklumat perdagangan kelajuan',
    coin: 'mata wang',
    timingTradeBetAmount: 'Jumlah pertaruhan dagangan yang sangat pantas',
    profit: 'Keuntungan',
    action: 'operasi',
    previewReportDay: 'Lihat laporan harian'
  },
  teamTimingTradeInfo: {
    title: 'Perdagangan Kelajuan Pasukan',
    profit: 'Keuntungan',
    subTitle: 'Maklumat transaksi kelajuan pasukan',
    timingTradeAmountFee: 'Yuran pesanan/perkhidmatan dagangan yang sangat pantas',
    timingTradePrizePoint: 'Bonus/rebat dagangan yang sangat pantas',
    rechargeInfo: 'Caj semula/Yuran Perkhidmatan',
    withdrawInfo: 'Pengeluaran/Yuran Perkhidmatan',
    exchangeInfo: 'Yuran Pertukaran/Perkhidmatan'
  },
  teamReportDay: {
    title: 'Laporan Harian Pasukan',
    subTitle: 'Laporan Harian Pasukan [{username}]',
    timingTradeBetAmountFee: 'Yuran pesanan/perkhidmatan dagangan yang sangat pantas',
    timingTradeBetPrizePoint: 'Bonus/Rebat Dagangan Cepat',
    rechargeAmountFee: 'Jumlah caj semula/yuran perkhidmatan',
    rechargePersonCount: 'Caj semula orang/bilangan transaksi',
    timingTradeUserAndCount: 'Bilangan peniaga kelajuan/bilangan transaksi',
    firstRechargePersonCount: 'Jumlah caj semula pertama/bilangan transaksi',
    withdrawAmountFee: 'amaun pengeluaran/yuran perkhidmatan',
    withdrawPersonCount: 'Bilangan orang yang mengeluarkan wang/urus niaga',
    exchangeAmountFee: 'Amaun Pertukaran/Yuran Perkhidmatan'
  },
  share: {
    title: 'Saya ingin berkongsi',
    qrCodeLabel: 'Kod QR',
    registerUrlLabel: 'Alamat Pendaftaran',
    inviteCodeLabel: 'Kod Jemputan',
    hasNoInviteCode: 'Akaun semasa tidak mempunyai kod jemputan,',
    generateInvitationCode: 'Cuba jana dengan satu klik',
    tipsPart1: 'Imbas kod QR di atas untuk mengisi maklumat pendaftaran untuk mendaftar',
    tipsPart2: 'Salin alamat pendaftaran dan isi maklumat pendaftaran untuk mendaftar',
    tipsPart3: 'Buka secara manual antara muka pendaftaran tapak ini dan isikan kod jemputan untuk mendaftar',
    saveImageError: 'Gagal menyimpan gambar, cuba tekan lama gambar dan simpan'
  },
  myTeam: {
    title: 'Pasukan Saya',
    usernamePlaceholder: 'Masukkan nama pengguna peringkat bawah',
    point: 'rebat (kelajuan/kontrak)',
    totalBalance: 'Baki',
    lastLoginTime: 'Masa Log Masuk Terakhir',
    noLoginTime: 'tiada'
  },
  userDetail: {
    username: 'nama pengguna',
    userType: 'Jenis Pengguna',
    title: 'Butiran Pengguna',
    pointPercentTiming: 'Rebat transaksi yang sangat pantas',
    pointPercentContract: 'Rebat transaksi kontrak',
    registerWay: 'Kaedah pendaftaran',
    teamCounts: 'Nombor pasukan',
    teamOnline: 'pasukan dalam talian',
    balance: 'Baki',
    registerTime: 'Masa pendaftaran',
    onlineStatus: 'status log masuk'
  },
  addUser: {
    title: 'Tambah Pengguna',
    addUserDirect: {
      userTypeLabel: 'Jenis Pengguna',
      usernameLabel: 'Nama pengguna',
      usernamePlaceholder: 'Sila masukkan nama pengguna akaun',
      pointTimingLabel: 'Rebat transaksi yang sangat pantas',
      pointContractLabel: 'Rebat transaksi kontrak',
      tips: 'Kata laluan awal ialah: "{password}"; sila ingatkan pengguna untuk menukar kata laluan dalam masa selepas membuka akaun',
      userTypeRequired: 'Sila pilih jenis akaun',
      usernameRequired: 'Sila masukkan nama pengguna akaun',
      pointTimingRequired: 'Sila pilih rebat transaksi yang pantas',
      pointContractRequired: 'Sila pilih rebat transaksi kontrak',
      copyTemplate: `
         Nama pengguna: {username};
         Kata laluan log masuk: {loginPassword};
         URL log masuk: {loginAddress};
         Rebat dagangan pantas: {timingTradePoint};
         Rebat dagangan kontrak: {contactTradePoint};
         `
    }
  },
  recharge: {
    title: 'Deposit',
    configIdLabel: 'Saluran deposit',
    chainNameLabel: 'nama rantai',
    amountLabel: 'Jumlah cas semula',
    UserCardNameLabel: 'Pembayar',
    userCardNamePlaceholder: 'Sila masukkan nama pembayar',
    fee: 'yuran perkhidmatan',
    receiveAmountTipsPart1: 'Caj semula',
    receiveAmountTipsPart2: ', perlu bayar',
    tipsPart1: 'Oleh kerana antara muka pembayaran dalam talian tidak stabil, buat masa ini hanya caj semula pindahan luar talian disokong! ',
    tipsPart2: 'Sila isikan jumlah pemindahan sebenar dengan benar, jika tidak, ia boleh menyebabkan semakan sistem gagal dan menjejaskan kemajuan cas semula. ',
    emptyPart1: 'Tiada saluran cas semula tersedia, ',
    emptyPart2: 'Ketik untuk mencuba semula',
    amountRequired: 'Amaun caj semula tidak boleh kosong',
    maxPrecisionError: 'Amaun cas semula boleh mempunyai sehingga {amountMaxPrecision} tempat perpuluhan',
    payUserNameError: 'Sila masukkan pembayar yang betul dan cuba lagi',
    userMobileLabel: 'Nombor telefon mudah alih',
    userMobilePlaceholder: 'Sila masukkan nombor telefon mudah alih pengguna',
    needPayLabel: 'Perlu bayar',
    needPayPlaceholder: 'Klik untuk memasukkan jumlah'
  },
  payDetail: {
    title: 'Pemindahan maklumat',
    addressLabel: 'Alamat deposit',
    rechargeAmount: 'Amount Recharge',
    bankNameLabel: 'Bank',
    branchLabel: 'Alamat cawangan',
    cardName: 'Nama',
    cardNum: 'nombor kad',
    uploadImgLabel: 'Kelayakan Pembayaran',
    uploadImgPlaceholder: 'Klik untuk memuat naik imej baucar pembayaran',
    uploadImgRequired: 'Sila muat naik gambar baucar pembayaran',
    vcTransferTipsPart1: '1. Salin alamat deposit atau imbas kod QR untuk deposit',
    vcTransferTipsPart2: '2. Muat naik gambar baucar pembayaran selepas deposit selesai',
    vcTransferTipsPart3: 'Untuk meningkatkan kecekapan deposit, sila pastikan anda memuat naik gambar sijil yang jelas dan berdefinisi tinggi, jika gambar maklumat yang berkaitan tidak jelas, ia boleh menyebabkan sistem gagal dalam semakan dan menjejaskan kemajuan deposit. ',
    bankCardTips: 'Untuk meningkatkan kecekapan mendepositkan wang, sila pastikan bahawa nama pemindah dan penghantar adalah sama; jika maklumat yang berkaitan tidak sepadan, ia boleh menyebabkan sistem gagal dalam semakan dan menjejaskan kemajuan daripada deposit itu. ',
    bankCardTransferSuccess: 'Saya telah berjaya memindahkan'
  },
  rechargeOrder: {
    title: 'Pesanan deposit',
    payAmount: 'Jumlah caj semula',
    receiveAmount: 'jumlah yang diterima'
  },
  identiti: {
    title: 'Maklumat nama sebenar',
    subTitle: 'Pengesahan nama sebenar termasuk pengesahan maklumat, pengesahan identiti',
    name: 'nama',
    idType: 'jenis dokumen',
    idNum: 'nombor ID',
    demand: 'memerlukan',
    informationVer: 'Pengesahan Maklumat',
    idAuthentication: 'Authentication',
    material: 'Bahan'
  },
  verified: {
    title: 'Pengesahan nama sebenar',
    idCardTypeLabel: 'Jenis Sijil',
    idCardFrontSideImgLabel: 'Kad Front SideImgLabel',
    idCardBackSideImgLabel: 'Bahagian belakang foto ID',
    idCardHandSideImgLabel: 'foto ID genggam',
    nameLabel: 'Nama dokumen',
    namePlaceholder: 'Sila masukkan nama ID anda',
    idCardNumLabel: 'Nombor kad ID',
    idCardNumPlaceholder: 'Sila masukkan nombor ID',
    fundPwdLabel: 'kata laluan dana',
    fundPwdPlaceholder: 'Sila masukkan kata laluan dana anda',
    tips: 'Setelah pengesahan maklumat diserahkan, ia tidak boleh diubah suai, sila semak dengan teliti dan isi dengan betul',
    idCardTypeRequired: 'Sila pilih jenis kad',
    idCardFrontSideImgDiperlukan: 'Sila muat naik foto hadapan kad pengenalan',
    idCardBackSideImgRequired: 'Sila muat naik foto belakang kad pengenalan',
    idCardHandSideImgDiperlukan: 'Sila muat naik foto ID genggam',
    nameRequired: 'Sila masukkan nama dokumen',
    idCardNumRequired: 'Sila masukkan nombor ID',
    fundPwdDiperlukan: 'Sila masukkan kata laluan dana anda',
    submitSuccess: 'Permintaan pengesahan berjaya diserahkan'
  },
  help: {
    title: 'Pusat Bantuan'
  },
  helpDetail: {
    title: 'Butiran Bantuan'
  },
  myMessage: {
    title: 'Mesej Saya'
  },
  messageDetail: {
    title: 'Butiran mesej'
  },
  withdraw: {
    title: 'Menarik diri',
    tips: 'Untuk memastikan keselamatan dana dan kecekapan pengeluaran; sila semak dengan teliti bahawa maklumat yang diisi adalah betul, dan yuran pengendalian yang dijana semasa proses pengeluaran akan ditolak daripada baki',
    receiveAmountTipsPart1: 'Tarik balik',
    receiveAmountTipsPart2: ', dijangka tiba',
    fee: 'yuran perkhidmatan',
    myBalance: 'Baki [{vcName}] saya:',
    configIdLabel: 'saluran pengeluaran',
    amountLabel: 'amaun pengeluaran',
    fundLabel: 'kata laluan dana',
    fundPlaceholder: 'Sila masukkan kata laluan dana anda',
    googleCodeLabel: 'Kod pengesahan Google',
    googleCodePlaceholder: 'Sila masukkan kod pengesahan Google 6 digit',
    maxPrecisionError: 'Amaun pengeluaran boleh mempunyai sehingga {amountMaxPrecision} tempat perpuluhan',
    amountRequired: 'Sila masukkan atau pilih jumlah pengeluaran yang betul',
    bankCardError: 'Sila pilih kad bank yang betul',
    fundPwdError: 'Sila masukkan kata laluan dana yang betul',
    walletAddressError: 'Sila pilih alamat dompet yang betul',
    success: 'Permintaan pengeluaran telah berjaya diserahkan, sila tunggu untuk diproses',
    emptyPart1: 'Tiada saluran pengeluaran tersedia, ',
    emptyPart2: 'Ketik untuk mencuba semula'
  },
  withdrawOrder: {
    title: 'Pesanan pengeluaran',
    requestAmount: 'Jumlah bil muatan',
    receiveAmount: 'jumlah yang diterima'
  },
  locales: {
    title: 'Tukar bahasa'
  },
  lines: {
    title: 'Pilihan baris',
    switchLine: 'switch line'
  },
  currencyPop: {
    deleteFavoriteSuccess: 'Berjaya memadam mata wang kegemaran',
    addFavoriteSuccess: 'Tambah mata wang kegemaran berjaya'
  },
  currencySelect: {
    currencyName: 'mata wang',
    currencyPlaceholder: 'Klik untuk memilih mata wang'
  },
  walletItem: {
    available: 'tersedia',
    convert: 'tukar (USDT)'
  },
  banks: {
    bankIdLabel: 'Bank',
    bankIdPlaceholder: 'Klik untuk memilih bank'
  },
  banksPop: {
    title: 'Pilih Bank',
    search: 'Masukkan kata kunci bank'
  },
  historyOrderDetail: {
    title: 'Butiran Pesanan',
    coin: 'Mata wang urus niaga',
    amount: 'jumlah pesanan',
    buyInClose: 'Harga beli',
    sellOutClose: 'Harga jualan',
    isQuest: 'Ada sebarang soalan tentang pesanan ini?',
    connectCustomer: 'Hubungi perkhidmatan pelanggan?'
  },
  pointSelect: {
    prizeGroupPlaceholder: 'Klik untuk memilih rebat pengguna'
  },
  walletAddressSelect: {
    title: 'Pilih alamat dompet',
    label: 'alamat dompet',
    placeholder: 'Klik untuk memilih alamat dompet'
  },
  myCardSelect: {
    title: 'Pilih akaun',
    label: 'menerima akaun',
    placeholder: 'Klik untuk memilih akaun'
  },
  amountInput: {
    amountRange: 'minimum {minAmount}, maksimum {maxAmount}',
    amountMin: 'Minimum {minAmount}, tiada had atas',
    amountErrorEmpty: '{label} salah, sila semak dan cuba lagi',
    amountErrorOutRange: '{label} berada di luar julat, sila semak dan cuba lagi'
  },
  amountFormItem: {
    placeholderOnlyMin: 'MinAmum {minAmount}, tiada had atas',
    placeholderHasMax: 'minimum {minAmount}, maksimum {maxAmount}',
    amountErrorEmpty: 'Jumlah adalah salah, sila cuba lagi selepas pengesahan',
    amountErrorOutRange: 'Jumlah di luar julat, sila sahkan dan cuba lagi'
  },
  common: {
    remark: 'remark',
    saveImage: 'Simpan setempat',
    online: 'dalam talian',
    offline: 'luar talian',
    profit: 'untung dan rugi',
    date: 'tarikh',
    period: 'tempoh',
    pointAmount: 'Jumlah rebat pengguna',
    point: 'Rebat pengguna',
    direction: 'arah',
    winLoss: 'Pendapatan',
    lose: 'kalah',
    add: 'Tambah baharu',
    win: 'menang',
    edit: 'Ubah suai',
    notBind: 'tidak terikat',
    alreadyBind: 'sudah terikat',
    enabled: 'didayakan',
    notEnabled: 'tidak didayakan',
    queryRange: 'Query Range',
    copy: 'Salin',
    orderNum: 'nombor pesanan',
    null: 'tiada',
    noData: 'Tiada data lagi',
    refreshSuccess: 'Segar semula berjaya',
    loadMoreData: 'Muatkan lebih banyak data',
    noMoreData: 'Tiada lagi data',
    lookMore: 'Lagi',
    more: 'Lagi'
  },
  date: {
    today: 'hari ini',
    yesterday: 'Semalam',
    last7Days: 'hampir 7 hari',
    last14Days: 'hampir 14 hari',
    split: 'ke'
  },
  button: {
    save: 'Simpan',
    logout: 'log keluar',
    confirm: 'OK',
    cancel: 'Batal',
    submit: 'Serahkan',
    addNow: 'Tambah sekarang',
    reset: 'set semula',
    nextStep: 'Seterusnya',
    goCertification: 'Pergi ke pensijilan'
  },
  confirm: {
    title: {
      logout: 'log keluar',
      unBindFundPassword: 'kata laluan dana tidak terikat',
      addUserDirect: 'Tambah Pengguna',
      addUserInfo: 'Tambah pengguna berjaya',
      jumpToRechargePage: 'Sahkan Lompat',
      unAuthentication: 'pengesahan nama tidak sebenar',
      noBindBankCard: 'Tiada kad bank ditambah',
      noBindCoinAddress: 'Tiada alamat dompet ditambah',
      tradeConfirm: 'Sahkan transaksi',
      sellOutSpotOrder: 'kedudukan untuk menjual',
      buyFinance: 'mengesahkan pembelian',
      redeemOrder: 'Ikrar penebusan perintah'
    },
    content: {
      logout: 'Adakah anda pasti untuk log keluar daripada akaun semasa?',
      unBindFundPassword: 'Kata laluan dana tidak terikat telah dikesan, untuk memastikan keselamatan akaun, sila ikat kata laluan dana anda dahulu',
      addUserDirect: 'Pengguna baharu akan ditambah tidak lama lagi, sila sahkan bahawa maklumat adalah betul dan klik OK untuk meneruskan, nama pengguna [ {username} ], jenis pengguna [ {userType} ], kata laluan log masuk [ {password} ], dan perbezaan antara rebat dagangan kelajuan saya [ {diffPointTiming} ], dan perbezaan rebat transaksi kontrak saya [ {diffPointContract} ]',
      addUserInfo: 'Nama pengguna [ {nama pengguna} ]; <br /> Kata laluan log masuk [ {kata laluan} ];<br /> URL Log Masuk [ {loginAddress} ];<br /> Rebat transaksi melampau [ {pointPercentTiming} ];<br / > /> Rebat transaksi kontrak [{pointPercentContract}];',
      jumpToRechargePage: 'Mengenai untuk melompat ke antara muka cas semula tiga pihak, sila klik sahkan untuk meneruskan',
      unAuthentication: 'Adalah dikesan bahawa akaun itu tidak menjalani pengesahan nama sebenar, untuk memastikan peredaran dana biasa, sila lakukan pengesahan nama sebenar dahulu',
      noBindBankCard: 'Adalah dikesan bahawa akaun tidak terikat atau didayakan dengan kad bank. Untuk memastikan peredaran dana biasa, sila tambah kad bank dahulu',
      noBindCoinAddress: 'Adalah dikesan bahawa akaun tersebut tidak mempunyai akaun mata wang maya terikat atau didayakan. Untuk memastikan peredaran dana biasa, sila tambah alamat akaun mata wang maya dahulu',
      tradeConfirm: 'Pesanan akan dihantar, sila sahkan maklumat pesanan adalah betul dan klik Sahkan Pesanan untuk menghantar',
      sellOutSpotOrder: 'Pesanan kedudukan akan dijual, sila sahkan bahawa operasi itu betul dan klik OK untuk meneruskan',
      buyFinance: 'Akan membeli [{coin}], beli bahagian: {amount}, sila sahkan bahawa operasi itu betul dan klik OK untuk meneruskan',
      redeemOrder: 'Pesanan ikrar ({orderNum}) akan ditebus, sila sahkan bahawa operasi itu betul dan klik Sahkan untuk meneruskan'
    }
  },
  message: {
    bindSuccess: 'Berjaya mengikat',
    successOperation: 'Operasi berjaya',
    logoutSuccess: 'Berjaya keluar',
    editSuccess: 'Berjaya diubah suai',
    addSuccess: 'Berjaya ditambahkan',
    copySuccess: 'Menyalin berjaya',
    copyFailed: 'Salin gagal'
  },
  vux: {
    'inline-calendar': {
      week_day_0: 'Hari',
      week_day_1: 'Satu',
      week_day_2: 'dua',
      week_day_3: 'tiga',
      week_day_4: 'empat',
      week_day_5: 'lima',
      week_day_6: 'Enam'
    },
    loading: {
      loading: 'memuatkan'
    }
  },
  helpItems: {
    title: {
      part1: 'Mengapa amaun yang ditukar dalam aset berubah? ',
      part2: 'Melupakan kaedah pengendalian kata laluan dana untuk transaksi OTC',
      part3: 'Ke manakah aliran dana selepas pembelian transaksi OTC selesai? ',
      part4: 'Mengapa anda mahu mengehadkan bilangan kali anda boleh mengubah suai nama panggilan anda',
      part5: 'Apakah maksud pemindahan, mengapa perlu pemindahan',
      part6: 'Bagaimana untuk mengira ekuiti akaun kontrak pengguna? ',
      part7: 'Apakah nilai stop loss dan take profit yang ditetapkan dalam kedudukan pembukaan? Bagaimana ia harus ditetapkan? ',
      part8: 'Bagaimana untuk mengurangkan risiko kontrak? ',
      part9: 'Apakah yang ditunjukkan oleh kuantiti dalam kedudukan terbuka kontrak? ',
      part10: 'Arahan mengenai pembubaran paksa',
      part11: 'Apakah peraturan perdagangan kontrak? ',
      part12: 'Apakah margin dalam perdagangan kontrak? ',
      part13: 'Apakah pesanan had dan pesanan pasaran? ',
      part14: 'Apakah yang diwakili oleh risiko transaksi kontrak',
      part15: 'Mengapa anda memerlukan penukaran mata wang? ',
      part16: 'Mengapa pihak yang satu lagi tidak menerima pemindahan dalam masa selepas pemindahan transaksi OTC? ',
      part17: 'Bagaimana untuk membeli Tether (USDT) melalui OTC? '
    },
    content: {
      part1: 'Nilai mata wang digital yang kini dipegang dalam Renminbi apabila ditukar kepada aset akan berubah disebabkan turun naik harga aset digital. Bilangan aset digital anda tidak berubah. ',
      part2: 'Jika anda terlupa kata laluan dana transaksi OTC, sila pergi ke "Tetapan Saya-Klik untuk menetapkan kata laluan dana" atau hubungi perkhidmatan pelanggan untuk menetapkan semula',
      part3: 'Selepas pesanan belian OTC selesai, dana akan memasuki akaun mata wang sah dalam aset. Jika anda perlu menggunakan aset yang dibeli OTC untuk dagangan kontrak atau dagangan niaga hadapan, sila pergi ke modul pemindahan dana untuk memindahkan. ',
      part4: 'Atas sebab keselamatan transaksi anda, kami pada masa ini mengehadkan nama panggilan untuk diubah suai sekali sahaja. ',
      part5: 'Untuk memastikan kebebasan dana antara pelbagai akaun anda dan untuk memudahkan kawalan risiko munasabah anda, akaun modul perdagangan utama dengan ini dibahagikan. Pemindahan merujuk kepada proses penukaran aset bersama antara pelbagai akaun dagangan. ',
      part6: '<p>Ekuiti akaun kontrak, kaedah pengiraan adalah seperti berikut:</p> <p>Ekuiti akaun kontrak = margin kedudukan + untung rugi terapung kedudukan + jumlah akaun semasa tersedia</p>',
      part7: 'Ambil untung dan henti rugi ialah had untung dan had kerugian yang anda tetapkan. Apabila jumlah henti untung dan henti rugi yang ditetapkan tercapai, sistem akan menutup kedudukan secara automatik. Ia boleh digunakan untuk kawalan risiko anda semasa membeli kontrak. Separuh daripada amaun ambil untung yang ditetapkan ialah: tingkatkan amaun x kuantiti x berganda leverage dan tetapkan henti rugi. Kami mengesyorkan agar anda menetapkannya mengikut situasi aset sebenar anda untuk mengawal risiko secara munasabah . ',
      part8: 'Anda boleh memindahkan aset yang tersedia bagi akaun yang tinggal ke akaun kontrak dengan memindahkan dana, atau mengurangkan risiko dengan mengurangkan kedudukan. ',
      part9: 'Kuantiti dalam kedudukan terbuka menunjukkan kuantiti mata wang yang anda jangkakan untuk beli. Sebagai contoh: pada halaman pembukaan pasangan dagangan BTC/USDT, pilih untuk membeli panjang, masukkan harga sebagai 1000USDT, dan masukkan kuantiti sebagai 10BTC, yang bermaksud: anda menjangkakan untuk membeli 10 BTC dengan harga unit 1000USDT. ',
      part10: '<p>Ijazah risiko ialah penunjuk untuk mengukur risiko aset anda. Apabila tahap risiko bersamaan dengan 100%, kedudukan anda dianggap dibubarkan. Tahap risiko=(margin kedudukan/ekuiti akaun kontrak)*100 %, untuk mengelakkan pengguna daripada mengatasi kedudukan mereka, sistem menetapkan nisbah pelarasan tahap risiko. Apabila tahap risiko mencapai nilai risiko yang ditetapkan oleh sistem, sistem akan memaksa pembubaran. Contohnya: jika nisbah pelarasan yang ditetapkan oleh sistem ialah 10%, maka apabila tahap risiko anda lebih besar daripada atau sama dengan 90%, semua kedudukan anda akan ditutup secara paksa oleh sistem. </p> <p>Nota: Jika sistem memaksa pembubaran yang disebabkan oleh risiko yang berlebihan, semua kedudukan anda akan ditutup, jadi saya harap anda boleh mengawal risiko anda dengan munasabah untuk mengelakkan kerugian yang tidak perlu</p>',
      part11: '<p>Jenis dagangan</p> <p>Jenis dagangan terbahagi kepada dua arah: buka posisi beli (beli) dan buka posisi jual (jual):</p> <p>Beli lama (Panggilan) bermaksud bahawa anda percaya bahawa indeks semasa mungkin meningkat, dan berharap untuk membeli sejumlah kontrak tertentu pada harga yang anda tetapkan atau harga pasaran semasa. </p> <p>Jualan pendek (menurun) bermakna anda percaya bahawa indeks semasa mungkin jatuh, dan berharap untuk menjual beberapa kontrak tertentu pada harga yang anda tetapkan atau harga pasaran semasa. </p> <p>Cara membuat pesanan</p> <p>Had pesanan: anda perlu menyatakan harga dan kuantiti pesanan</p> <p>Pesanan pasaran: anda hanya perlu menetapkan kuantiti daripada pesanan , harga ialah harga pasaran semasa</p> <p>Kedudukan</p> <p>Apabila pesanan pembukaan yang anda serahkan selesai, ia dipanggil kedudukan</p> <p>Masalah penghantaran kontrak </p> <p>Kontrak platform ialah kontrak kekal tanpa masa penghantaran yang ditetapkan. Selagi syarat pembubaran sistem tidak dipenuhi atau anda tidak menutup kedudukan secara manual, anda boleh memegang jawatan itu secara kekal. </p> <p>Sistem menutup kedudukan</p> <p>1: Sistem secara automatik menutup kedudukan apabila nilai set stop untung dan stop loss dicapai</p> <p>2: Risiko terlalu tinggi, sistem memaksa kedudukan ditutup </p>',
      part12: '<p>Dalam transaksi kontrak, pengguna boleh mengambil bahagian dalam transaksi kontrak dengan membayar dana sebagai jaminan kewangan untuk pelaksanaan kontrak mengikut harga dan kuantiti kontrak, mengikut gandaan leveraj yang sepadan, dan dana ini adalah margin kontrak. Pengguna akan menduduki margin apabila membuka kedudukan, dan lebih banyak margin untuk membuka kedudukan diduduki, lebih tinggi risiko akaun. </p> <p>Margin = (harga pembukaan * kuantiti) / nisbah leverage</p>',
      part13: 'Pesanan had merujuk kepada harga yang anda jangkakan untuk mempercayakan platform untuk menjalankan urus niaga, dan pesanan pasaran merujuk kepada mempercayakan secara langsung platform untuk menjalankan urus niaga pada harga semasa. Dalam peraturan untuk membuka kedudukan, pesanan pasaran diutamakan berbanding pesanan had. Jika anda memilih pesanan had, sila buka kedudukan yang munasabah mengikut harga pasaran mata wang semasa untuk mengelakkan kerugian yang disebabkan oleh harga pembukaan yang tidak munasabah. ',
      part14: 'Tahap risiko ialah penunjuk risiko dalam akaun kontrak anda, dan tahap risiko bersamaan 100% dianggap pembubaran. Kami mencadangkan anda, apabila risiko anda melebihi 50%, anda perlu membuka posisi dengan berhati-hati untuk mengelakkan kerugian akibat pembubaran. Anda boleh mengurangkan risiko anda dengan menambah dana aset kontrak yang tersedia, atau mengurangkan kedudukan. ',
      part15: 'Fungsi pertukaran adalah untuk membolehkan peredaran dana lancar dalam mata wang berbeza dalam aset anda, dan QCC yang diperolehi dalam akaun niaga hadapan boleh ditukar secara bebas kepada USDT untuk dagangan. USDT dalam akaun lain juga boleh ditukar secara bebas kepada QCC untuk transaksi. ',
      part16: 'Pertama sekali, sila pastikan bahawa kaedah pembayaran yang anda isi semasa memindahkan wang adalah sama seperti yang dipaparkan pada halaman butiran pesanan. Kemudian sila sahkan sama ada kaedah pembayaran anda adalah segera atau tertangguh. Akhir sekali, sila hubungi bank dan institusi pembayaran anda untuk penyelenggaraan sistem atau sebab lain. ',
      part17: '<p>Kaedah 1: Pilih pesanan yang anda ingin beli melalui senarai beli dan jual OTC untuk membeli atau menjual. </p> <p>Kaedah 2: Klik butang terbitkan untuk menerbitkan pesanan beli atau jual mengikut keperluan anda untuk transaksi pantas. Sistem ini akan memadankan anda dengan cepat dengan pembeli dan penjual. </p> <p>Nota: Jika pesanan pembelian tidak dibayar selepas 15 minit, sistem akan membatalkan pesanan secara automatik, sila bayar dalam masa. Jika pesanan dibatalkan lebih daripada 3 kali pada hari yang sama, transaksi tidak boleh dijalankan semula pada hari yang sama, dan pihak berkuasa perdagangan akan dipulihkan pada hari berikutnya. </p>'
    }
  }
}



// WEBPACK FOOTER //
// ./src/locales/ms.js